import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, apiErr } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);      // null=checking, false=anon, obj=authed
  const [workspaces, setWorkspaces] = useState([]);

  const loadWorkspaces = useCallback(async () => {
    try {
      const { data } = await api.get("/workspaces");
      setWorkspaces(data);
    } catch (e) { /* ignore */ }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      if (!localStorage.getItem("ws_id")) localStorage.setItem("ws_id", data.workspace_id);
      setUser(data);
      loadWorkspaces();
    } catch (e) {
      setUser(false);
    }
  }, [loadWorkspaces]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    try {
      await api.post("/auth/login", { email, password });
      await checkAuth();
      return { ok: true };
    } catch (e) { return { ok: false, error: apiErr(e) }; }
  };

  const register = async (email, password, name) => {
    try {
      await api.post("/auth/register", { email, password, name });
      await checkAuth();
      return { ok: true };
    } catch (e) { return { ok: false, error: apiErr(e) }; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("ws_id");
    setUser(false);
  };

  const switchWorkspace = async (wsId) => {
    localStorage.setItem("ws_id", wsId);
    await checkAuth();
  };

  return (
    <AuthContext.Provider value={{ user, setUser, workspaces, login, register, logout, switchWorkspace, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
